import { createName, saveOrder, selectClient } from '@entities/cart';
import { debounce } from 'lodash';
import { useCallback, useEffect } from 'react';
import { useAppDispatch, useAppSelector, useUser } from '@shared/hooks';
import type { Client } from '@shared/types/cart';

export const useClientData = () => {
  const dispatch = useAppDispatch();
  const client = useAppSelector(selectClient);

  const { user } = useUser();

  // const user = useAppSelector(selectUser);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleChange = useCallback(
    debounce((value: any, field: string, client: Client) => {
      let data = {};
      if (field === 'first_name' || field === 'last_name' || field === 'middle_name') {
        data = { full_name: createName(client, field, value) };
      } else {
        data = { [field]: value };
      }
      dispatch(saveOrder(data));
    }, 300),

    []
  );

  useEffect(() => {
    if (
      !client.first_name &&
      !client.last_name &&
      !client.middle_name &&
      !client.phone &&
      !client.email
    ) {
      // const fullName = getFullNameM(user?.first_name, user?.middle_name, user?.last_name);
      dispatch(
        saveOrder({
          full_name: `${user?.last_name} ${user?.first_name} ${user?.middle_name}`,
          phone: user?.phonenumber ?? '',
          email: user?.email,
        })
      );
    }
  }, [
    client,
    user?.first_name,
    user?.last_name,
    user?.middle_name,
    user?.phonenumber,
    user?.email,
    dispatch,
  ]);
  const middle_name = client?.middle_name || user?.middle_name || '';
  // console.log('name:', middle_name);
  // console.log('client:', client);
  // console.log('user:', user);

  return {
    first_name: client.first_name ?? user?.first_name,
    last_name: client.last_name ?? user?.last_name,
    middle_name,
    phone: client.phone ? client.phone : user?.phonenumber ?? '',
    email: client.email ?? user?.email,
    handleChange,
    client,
  };
};
